import { ReactElement, useState } from 'react'
import { Button, Group, Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { SpinnerButton } from './SpinnerButton'

export type ConfirmationModalRenderButtonProps = { onClick: () => void }
export type ConfirmationModalProps = {
  action: () => void
  alertMessage: string | ReactElement
  renderButton: (renderProps: ConfirmationModalRenderButtonProps) => ReactElement
  isLoading?: boolean
}

export const ConfirmationModal = (props: ConfirmationModalProps) => {
  const { alertMessage, action, isLoading } = props

  const [opened, { open, close }] = useDisclosure(false)

  const onClickHanlder = () => {
    open()
  }

  const handleClose = () => {
    close()
  }

  const handleContinue = async () => {
    await action()
    close()
  }

  return (
    <>
      {alertMessage && (
        <Modal opened={opened} onClose={handleClose} centered={true}>
          <Modal.Body>{alertMessage}</Modal.Body>
          <div className='d-flex justify-content-end gap-2 mt-10'>
            <Group>
              <Button size='sm' variant='secondary' onClick={handleClose}>
                Cancel
              </Button>
              <SpinnerButton loading={!!isLoading} variant='primary' onClick={handleContinue}>
                Proceed
              </SpinnerButton>
            </Group>
          </div>
        </Modal>
      )}
      {props.renderButton({ onClick: onClickHanlder })}
    </>
  )
}
